import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 导入认证工具，确保拦截器被注册
import './utils/auth'

// 监控标题变化，确保标题一致性
const titleObserver = new MutationObserver(() => {
  if (document.title !== '广州市劳动保障学会') {
    document.title = '广州市劳动保障学会'
  }
})

// 监视document.title变化
titleObserver.observe(
  document.querySelector('title'),
  { subtree: true, characterData: true, childList: true }
)

// 创建应用实例
const app = createApp(App)

// 添加全局路由保护
app.config.globalProperties.$checkAuth = () => {
  const auth = require('@/utils/auth').default;
  return auth.isTokenValid();
}

// 使用路由和状态管理
app.use(store).use(router)

// 挂载应用
app.mount('#app')

// 添加全局错误处理
// eslint-disable-next-line no-unused-vars
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue应用错误:', err, info)
}

// 确保路由守卫正常工作
// 控制台调试日志（控制台调试功能）
// console.log('�� 应用启动完成，路由守卫已注册')
